import { render, staticRenderFns } from "./editContent.vue?vue&type=template&id=efbc0b22&"
import script from "./editContent.vue?vue&type=script&lang=js&"
export * from "./editContent.vue?vue&type=script&lang=js&"
import style0 from "./editContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports